export default __webpack_public_path__ + "static/media/card-image10.cb8debf8.png";